import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class PhotoEditorService {

  private saveListener = new Subject<any>();

  constructor() { }

  public save() {
    this.saveListener.next();
  }

  public listenSave() {
    return this.saveListener.asObservable();
  }
}
